var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.translations)?_c('a',{staticClass:"bypass-block",attrs:{"href":"#main-content","data-skip-link":""},on:{"click":function($event){$event.preventDefault();return _vm.focusMain.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.translations.bypass_block.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }